import { z } from "zod";
import { DateTime } from "luxon";
import { components } from "@opstel/gen/api/v2";
import { dateTimeSchema } from "../utils/dateTime";

export interface BorderTrain {
  name: string;
  datetime?: DateTime<true>;
  track?: string;
}

export interface BorderTrainsResponse {
  arrivingTrains: BorderTrain[];
  departingTrains: BorderTrain[];
}

export const borderTrainSchema = z.object({
  name: z.string(),
  datetime: dateTimeSchema.optional(),
  track: z.string().optional(),
}) satisfies z.ZodType<BorderTrain, components["schemas"]["BorderTrain"]>;

export const borderTrainsResponseSchema = z.object({
  arrivingTrains: z.array(borderTrainSchema),
  departingTrains: z.array(borderTrainSchema),
}) satisfies z.ZodType<BorderTrainsResponse, components["schemas"]["BorderTrainsResponse"]>;
